import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../ui/AnimatedProgressProvider";
import MySnow from '../../components/ui/snow';

export default function PageLoader({ progress, step, visible }) {
  if (!visible) return null;

  return (
    <div className="overlay">
      {/* <MySnow snowflakeCount={200} radius={[5.0, 16.0]}/> */}
      <div className="loader-container">
        <AnimatedProgressProvider
          valueStart={0}
          valueEnd={progress}
          duration={1.4}
          easingFunction={easeQuadInOut}
        >
          {value => (
            <>            
              <CircularProgressbar
                value={value}
                text={``}
                strokeWidth={3}
                // text={`${Math.round(value)}%`}
                styles={buildStyles({ pathTransition: "none" })}
              />
              {/* <div className="christmas-tree"><span></span></div> */}
            </>
          )}
        </AnimatedProgressProvider>
        <p className="loader-step">{step}</p>
      </div>
    </div>
  );
}